import request from '@/utils/request'


// 查询挑战赛类型列表
export function listType(query) {
  return request({
    url: '/challenge/type/list',
    method: 'get',
    params: query
  })
}

// 查询挑战赛类型分页
export function pageType(query) {
  return request({
    url: '/challenge/type/page',
    method: 'get',
    params: query
  })
}

// 查询挑战赛类型详细
export function getType(data) {
  return request({
    url: '/challenge/type/detail',
    method: 'get',
    params: data
  })
}

// 新增挑战赛类型
export function addType(data) {
  return request({
    url: '/challenge/type/add',
    method: 'post',
    data: data
  })
}

// 修改挑战赛类型
export function updateType(data) {
  return request({
    url: '/challenge/type/edit',
    method: 'post',
    data: data
  })
}

// 删除挑战赛类型
export function delType(data) {
  return request({
    url: '/challenge/type/delete',
    method: 'post',
    data: data
  })
}
